export const VAT_RATE_PERCENT = 21;
export const normalizeMinor = (value) => Number.isSafeInteger(value) && value > 0 ? value : 0;
export const roundDiscountPercent = (savingsMinor, referencePriceMinor) => {
    const savings = normalizeMinor(savingsMinor);
    const reference = normalizeMinor(referencePriceMinor);
    return savings > 0 && reference > 0 ? Math.round((savings * 100) / reference) : 0;
};
export const calculateProportionalSavings = (twelveMonthPriceMinor, durationMonths, actualPriceMinor) => {
    const basePrice = normalizeMinor(twelveMonthPriceMinor);
    const price = normalizeMinor(actualPriceMinor);
    const duration = Number.isSafeInteger(durationMonths) && durationMonths > 0 ? durationMonths : 0;
    const referencePriceMinor = Math.round((basePrice * duration) / 12);
    const savingsMinor = Math.max(0, referencePriceMinor - price);
    return {
        referencePriceMinor,
        savingsMinor,
        discountPercent: roundDiscountPercent(savingsMinor, referencePriceMinor)
    };
};
export const calculateTaxTotals = (subtotalMinor) => {
    const subtotal = normalizeMinor(subtotalMinor);
    const vatMinor = Math.round((subtotal * VAT_RATE_PERCENT) / 100);
    return {
        subtotalMinor: subtotal,
        vatMinor,
        totalMinor: subtotal + vatMinor
    };
};
export const calculateCartTotals = (lines) => calculateTaxTotals(lines.reduce((subtotalMinor, line) => {
    const quantity = Number.isSafeInteger(line.quantity) && line.quantity > 0 ? line.quantity : 0;
    return subtotalMinor + normalizeMinor(line.priceMinor) * quantity;
}, 0));
export const getMaximumSavingsId = (variants) => {
    const eligible = variants.filter((variant) => variant.savingsMinor > 0 && variant.referencePriceMinor > 0);
    if (!eligible.length)
        return undefined;
    return eligible.slice(1).reduce((best, candidate) => {
        const candidateRatio = candidate.savingsMinor * best.referencePriceMinor;
        const bestRatio = best.savingsMinor * candidate.referencePriceMinor;
        return candidateRatio > bestRatio ? candidate : best;
    }, eligible[0]).id;
};
